import { Component, Input, OnInit } from '@angular/core';
import { CertificateNote_Interface, Empty_CertificateNote_Interface } from 'src/app/Interface/CertificateNote_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { CertificateNoteService } from 'src/app/Service/CertificateNote/CertificateNote.service';

@Component({
  selector: 'app-DataEntityCertificateNote',
  templateUrl: './DataEntityCertificateNote.component.html',
  styleUrls: ['./DataEntityCertificateNote.component.css']
})
export class DataEntityCertificateNoteComponent implements OnInit {

  @Input() inner_Calibration_Device_Id:number=0
  Filter_Dsc: String = ''
  Seleted_Note_Id: String = ''
  constructor(
    private CertificateNote_Service: CertificateNoteService,
    private Alertify_Service: AlertifyService,
  ) { }

  ngOnInit() {
    this.Read_Data_CertificateNote() 
  }


  InProccessing: boolean = false
  DataList_CertificateNote: Array<CertificateNote_Interface> = []
  Read_Data_CertificateNote() {
    this.InProccessing = true
    this.CertificateNote_Service.GetActiveList().subscribe(
      data => {
        this.InProccessing = false
        this.DataList_CertificateNote = data
        this.Read_Data_CertificateNote_Selected()
      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )
  }

  SubmitCertificate() {
    this.CertificateNote_Service.SubmitCertificate(this.inner_Calibration_Device_Id, Number(this.Seleted_Note_Id)).subscribe(
      data => {
        if (data.id == 0) {
          this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")
          this.Read_Data_CertificateNote_Selected()
        }
        else if (data.id == -2){
          this.Alertify_Service.ErrorMessage("امکان ثبت وجود ندارد")
        }
        else{
          this.Alertify_Service.ErrorMessage("نوت مورد نظر در لیست موجود است")
        }
      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )
  }

  DeleteCertificateNote(id:number) {
    this.CertificateNote_Service.DeleteCertificate(this.inner_Calibration_Device_Id, id).subscribe(
      data => {
        if (data.id == 0) {
          this.Alertify_Service.SuccessMessage("اطلاعات حذف شد")
          this.Read_Data_CertificateNote_Selected()
        }
        else if (data.id == -2){
          this.Alertify_Service.ErrorMessage("امکان ثبت وجود ندارد")
        }
        else{
          this.Alertify_Service.ErrorMessage("نوت مورد نظر در لیست موجود است")
        }
      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )
  }

  Selected_DataList_CertificateNote: Array<CertificateNote_Interface> = []
  Read_Data_CertificateNote_Selected() {
    this.InProccessing = true
    this.CertificateNote_Service.GetActiveListCertificate(this.inner_Calibration_Device_Id).subscribe(
      data => {
        this.InProccessing = false
        this.Selected_DataList_CertificateNote = data
      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )
  }


  Change_Filter_title(){
    this.Seleted_Note_Id=''
  }

}
